import NetworkConnectionMonitor from 'scripts/infrastructure/backends/network_connection_monitor';
import NetworkConnectionEventHandler from 'actions/health/network_connection_event_handler';

export default function configureNetworkEventHandler(context) {
  let networkEventMonitor = new NetworkConnectionMonitor(window);
  networkEventMonitor.addObserver(new NetworkConnectionEventHandler(context));
}



// WEBPACK FOOTER //
// ./src/scripts/configuration/configure_network_event_handler.js